import styled from 'styled-components';

export const ButtonContainer = styled.button`
  text-decoration: none;
  border: 2px solid var(--lightBlue) !important;
  border-color: ${props => props.cart ? "var(--mainYellow)" : "var(--lightBlue)"} !important;
  background-color: transparent;
  color: ${props => props.cart ? "var(--mainYellow)" : "var(--lightBlue)"} !important;
  font-weight: bold;
  border-radius: 5px;
  &:hover {
    background-color: ${props => props.cart ? "var(--mainYellow)" : "var(--lightBlue)"} !important;;
    color: var(--mainBlue) !important;
    transition: all 0.3s ease-in-out;
  }
  &:focus {
    outline: none;
  }
`;

export const NavContainer = styled.nav`
  width: 100%;
  height: 75px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px 0px 10px;
  background-color: var(--mainBlue) !important;
`;